export default {
    'zh_CN': {
        'property.housing.id.label': '主键',
        'property.housing.id.holder': '请输入主键',
        
        
        'property.housing.id.required': '主键必填',
        'property.housing.housingNo.label': '房屋编号',
        'property.housing.housingNo.holder': '请输入房屋编号',
        'property.housing.housingNo.max': '房屋编号最多80个字符',
        
        'property.housing.housingNo.required': '房屋编号必填',
        'property.housing.name.label': '名称',
        'property.housing.name.holder': '请输入名称',
        'property.housing.name.max': '名称最多30个字符',
        
        'property.housing.name.required': '名称必填',
        'property.housing.area.label': '面积',
        'property.housing.area.holder': '请输入面积',
        'property.housing.area.max': '面积最多30个字符',
        
        'property.housing.area.required': '面积必填',
        'property.housing.remark.label': '备注',
        'property.housing.remark.holder': '请输入备注',
        'property.housing.remark.max': '备注最多255个字符',
        
        'property.housing.remark.required': '备注必填',
        'property.housing.createTime.label': '创建时间',
        'property.housing.createTime.holder': '请输入创建时间',
        'property.housing.createTime.required': '创建时间必填',
        'property.housing.updateTime.label': '修改时间',
        'property.housing.updateTime.holder': '请输入修改时间',
        'property.housing.updateTime.required': '修改时间必填',
        'property.housing.isDelete.label': '是否删除',
        'property.housing.isDelete.holder': '请输入是否删除',
        
        
        'property.housing.isDelete.dictionary': ()=>[{value:0,label:'删除'}],
        'property.housing.isDelete.required': '是否删除必填'
    },
    'zh_TW': {
        'property.housing.id.label': '主键',
        'property.housing.id.holder': '請輸入主键',
        
        
        'property.housing.id.required': '主键必填',
        'property.housing.housingNo.label': '房屋编号',
        'property.housing.housingNo.holder': '請輸入房屋编号',
        
        
        'property.housing.housingNo.required': '房屋编号必填',
        'property.housing.name.label': '名称',
        'property.housing.name.holder': '請輸入名称',
        
        
        'property.housing.name.required': '名称必填',
        'property.housing.area.label': '面积',
        'property.housing.area.holder': '請輸入面积',
        
        
        'property.housing.area.required': '面积必填',
        'property.housing.remark.label': '备注',
        'property.housing.remark.holder': '請輸入备注',
        
        
        'property.housing.remark.required': '备注必填',
        'property.housing.createTime.label': '创建时间',
        'property.housing.createTime.holder': '請輸入创建时间',
        
        
        'property.housing.createTime.required': '创建时间必填',
        'property.housing.updateTime.label': '修改时间',
        'property.housing.updateTime.holder': '請輸入修改时间',
        
        
        'property.housing.updateTime.required': '修改时间必填',
        'property.housing.isDelete.label': '是否删除',
        'property.housing.isDelete.holder': '請輸入是否删除',
        
        
        'property.housing.isDelete.required': '是否删除必填'
    },
    'en_US': {
        'property.housing.id.label': 'id',
        'property.housing.id.holder': 'Enter id',
        'property.housing.id.max': 'id max length: 主键',
        
        
        'property.housing.id.required': 'id required',
        'property.housing.housingNo.label': 'housingNo',
        'property.housing.housingNo.holder': 'Enter housingNo',
        'property.housing.housingNo.max': 'housingNo max length: 房屋编号',
        
        
        'property.housing.housingNo.required': 'housingNo required',
        'property.housing.name.label': 'name',
        'property.housing.name.holder': 'Enter name',
        'property.housing.name.max': 'name max length: 名称',
        
        
        'property.housing.name.required': 'name required',
        'property.housing.area.label': 'area',
        'property.housing.area.holder': 'Enter area',
        'property.housing.area.max': 'area max length: 面积',
        
        
        'property.housing.area.required': 'area required',
        'property.housing.remark.label': 'remark',
        'property.housing.remark.holder': 'Enter remark',
        'property.housing.remark.max': 'remark max length: 备注',
        
        
        'property.housing.remark.required': 'remark required',
        'property.housing.createTime.label': 'createTime',
        'property.housing.createTime.holder': 'Enter createTime',
        'property.housing.createTime.max': 'createTime max length: 创建时间',
        
        
        'property.housing.createTime.required': 'createTime required',
        'property.housing.updateTime.label': 'updateTime',
        'property.housing.updateTime.holder': 'Enter updateTime',
        'property.housing.updateTime.max': 'updateTime max length: 修改时间',
        
        
        'property.housing.updateTime.required': 'updateTime required',
        'property.housing.isDelete.label': 'isDelete',
        'property.housing.isDelete.holder': 'Enter isDelete',
        'property.housing.isDelete.max': 'isDelete max length: 是否删除',
        
        
        'property.housing.isDelete.required': 'isDelete required'
    }
}
